/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonBtcStakingHistoryListInfo } from '../models/BabylonBtcStakingHistoryListInfo';
import type { BabylonBtcStakingTransactionListInfo } from '../models/BabylonBtcStakingTransactionListInfo';
import type { BabylonBtcStakingTrxDetailHistoryGroupListInfo } from '../models/BabylonBtcStakingTrxDetailHistoryGroupListInfo';
import type { BabylonBtcStakingTrxSummaryInfo } from '../models/BabylonBtcStakingTrxSummaryInfo';
import type { BabylonStakingSummaryInfo } from '../models/BabylonStakingSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonStakingControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonBtcStakingTrxSummaryInfo OK
     * @throws ApiError
     */
    public getLatestBtcStakingTransactionList1({
        size = 5,
    }: {
        size?: number,
    }): CancelablePromise<Array<BabylonBtcStakingTrxSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/staking/btc/transaction/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingTransactionListInfo OK
     * @throws ApiError
     */
    public getBtcStakingTransactionList1({
        status,
        page = 1,
        size = 25,
    }: {
        status?: Array<'PENDING' | 'VERIFIED' | 'ACTIVE' | 'UNBONDING' | 'WITHDRAWABLE' | 'WITHDRAWN' | 'UNBONDED' | 'EXPIRED' | 'EXPANDED' | 'SLASHED'>,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakingTransactionListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/staking/btc/transaction/list',
            query: {
                'status': status,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingHistoryListInfo OK
     * @throws ApiError
     */
    public getBtcStakingTransactionHistoryList1({
        status,
        page = 1,
        size = 25,
    }: {
        status?: Array<'PENDING' | 'VERIFIED' | 'ACTIVE' | 'UNBONDING' | 'WITHDRAWABLE' | 'WITHDRAWN' | 'UNBONDED' | 'EXPIRED' | 'EXPANDED' | 'SLASHED'>,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakingHistoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/staking/btc/transaction/history/list',
            query: {
                'status': status,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingTrxDetailHistoryGroupListInfo OK
     * @throws ApiError
     */
    public getBtcStakingTransactionDetailHistoryList1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<BabylonBtcStakingTrxDetailHistoryGroupListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/staking/btc/transaction/detail/history/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns BabylonStakingSummaryInfo OK
     * @throws ApiError
     */
    public getBtcStakingSummary1(): CancelablePromise<BabylonStakingSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/staking/btc/summary',
        });
    }

}
